import axios, { AxiosResponse } from "axios";
import { General } from "./general";
import { Users } from "../models/users.model";
import UserGroup from "../models/userGroup.model";
import { Infra2_User } from "../models/infradigital/infra2_user.model";

export function UsersService(props?: any) {
    const getInfra2_UserGroups = (): Promise<AxiosResponse> => {
        return axios.get<UserGroup[]>(`${General.InfraDigital_API}/groups/getUserGroupsByApp?slug=${General.ProjectSlug}`
        );
    };

    const getInfra2_UserByUserName = (userName: string): Promise<AxiosResponse> => {
        return axios.post<Infra2_User, AxiosResponse<Infra2_User>>(`${General.InfraDigital_API}/users/getUsersByUsername?username=${userName}`,
        );
    };


    const getUsers = async (): Promise<AxiosResponse> => {
        return axios.get<Users>(`${General.API_URL}/GetUsers`);

    };

    const getUserByUserName = async (username: string): Promise<AxiosResponse> => {
        return axios.post<Users>(`${General.API_URL}/GetUserByEmail`, username);

    };

    const getInfraDigitalUsersByApp = (): Promise<AxiosResponse> => {
        return axios.get<UserGroup[]>(`${General.InfraDigital_API}/users/getUsers?appSlug=${General.ProjectSlug}`
        );
    };


    const saveUsers = async (users: Users[]): Promise<AxiosResponse> => {
        return axios.post<Infra2_User, AxiosResponse<Infra2_User>>(`${General.API_URL}/saveUsers`, users);
    };

    return (
        {
            getInfra2_UserByUserName,
            getUsers,
            getUserByUserName,
            // getSessionUser,
            getInfra2_UserGroups,
            getInfraDigitalUsersByApp,
            saveUsers
        }
    );

}